/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GarantieReferentielDto,
  ReferentialItemDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GarantieReferentielDtoFromJSON,
    GarantieReferentielDtoToJSON,
    ReferentialItemDtoFromJSON,
    ReferentialItemDtoToJSON,
} from '../models/index';

export interface GetReferentialGuaranteesForFunnelRequest {
    tunnelId: string;
}

/**
 * 
 */
export class ReferentialsApi extends runtime.BaseAPI {

    /**
     * Renvoie le socle de garanties de la branche du tunnel. Le front n\'a pas à connaître la branche : il transmet l\'identifiant du tunnel.
     * Garanties du référentiel éligibles à un tunnel
     */
    async getReferentialGuaranteesForFunnelRaw(requestParameters: GetReferentialGuaranteesForFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GarantieReferentielDto>>> {
        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling getReferentialGuaranteesForFunnel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/garanties/tunnels/{tunnelId}`.replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GarantieReferentielDtoFromJSON));
    }

    /**
     * Renvoie le socle de garanties de la branche du tunnel. Le front n\'a pas à connaître la branche : il transmet l\'identifiant du tunnel.
     * Garanties du référentiel éligibles à un tunnel
     */
    async getReferentialGuaranteesForFunnel(requestParameters: GetReferentialGuaranteesForFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GarantieReferentielDto>> {
        const response = await this.getReferentialGuaranteesForFunnelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Natures de rémunération
     */
    async getRemunerationNaturesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReferentialItemDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/natures-remuneration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReferentialItemDtoFromJSON));
    }

    /**
     * Natures de rémunération
     */
    async getRemunerationNatures(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReferentialItemDto>> {
        const response = await this.getRemunerationNaturesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Types de support
     */
    async getSupportTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReferentialItemDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/referentiel/types-support`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReferentialItemDtoFromJSON));
    }

    /**
     * Types de support
     */
    async getSupportTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReferentialItemDto>> {
        const response = await this.getSupportTypesRaw(initOverrides);
        return await response.value();
    }

}
